import { render, staticRenderFns } from "./FlaggedUsersAdmin.vue?vue&type=template&id=138b010d&"
import script from "./FlaggedUsersAdmin.vue?vue&type=script&lang=js&"
export * from "./FlaggedUsersAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports